// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { AiOutlineDownload, AiOutlinePlus } from "react-icons/ai";
// import { toast } from "react-toastify";
// import { useRef } from "react";



// export const SellerFinance = () => {
//   const [bankData, setBankData] = useState([]);
//   const [showAddBank, setShowAddBank] = useState(false);
//   const hasFetched = useRef(false);

//   const seller_id = localStorage.getItem("seller_id");
//   console.log("Fetched Seller ID:", seller_id);

//   const [incomeData] = useState([
//     { id: 1, product: "Wireless Headphones", amount: "₹1,200", status: "To Release" },
//     { id: 2, product: "Running Shoes", amount: "₹1,899", status: "Released" },
//     { id: 3, product: "T-shirt - Cotton", amount: "₹599", status: "To Release" },
//   ]);

//   const [balance] = useState("₹5,450");


// useEffect(() => {
//   if (!seller_id) {
//     toast.error("Seller ID not found");
//     return;
//   }

//   if (hasFetched.current) return;
//   hasFetched.current = true;

//   fetchBankStatement();
// }, [seller_id]);


//   const fetchBankStatement = async () => {
//     try {
//       const response = await axios.post(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_by_id_bank_statement",
//         { seller_id }
//       );
//       console.log("Seller ID:", seller_id)
//       console.log("Bank Statement Response:", response.data);

//       if (response.data.status) {
//         setBankData(response.data.data);
//       } else {
//         setBankData([]);
//         toast.warning(response.data.message);
//       }
//     } catch (error) {
//       console.error("Bank Statement Error:", error);
//       toast.error("Failed to fetch bank statement");
//     }
//   };

//   return (
//     <>
//       <div className="page-content">
//         <div className="container-fluid">
//           {/* PAGE TITLE */}
//           <div className="row">
//             <div className="col-12">
//               <div className="page-title-box">
//                 <h4 className="mb-0 fw-semibold">Finance Center</h4>
//                 <ol className="breadcrumb mb-0">
//                   <li className="breadcrumb-item">
//                     <a href="#">Dashboard</a>
//                   </li>
//                   <li className="breadcrumb-item active">Finance</li>
//                 </ol>
//               </div>
//             </div>
//           </div>

//           {/* INCOME OVERVIEW */}
//           <div className="row mb-4">
//             <div className="col-md-6">
//               <div className="card">
//                 <div className="card-header d-flex justify-content-between">
//                   <h5 className="mb-0">Income Overview</h5>
//                   <button className="btn btn-sm btn-outline-primary">
//                     <AiOutlineDownload /> Download Statement
//                   </button>
//                 </div>
//                 <div className="card-body p-0">
//                   <table className="table table-bordered mb-0">
//                     <thead className="table-light">
//                       <tr>
//                         <th>#</th>
//                         <th>Product</th>
//                         <th>Amount</th>
//                         <th>Status</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {incomeData.map((item, index) => (
//                         <tr key={item.id}>
//                           <td>{index + 1}</td>
//                           <td>{item.product}</td>
//                           <td>{item.amount}</td>
//                           <td>
//                             <span
//                               className={`badge ${
//                                 item.status === "Released"
//                                   ? "bg-success"
//                                   : "bg-warning text-dark"
//                               }`}
//                             >
//                               {item.status}
//                             </span>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>

//             {/* BALANCE */}
//             <div className="col-md-6">
//               <div className="card text-center">
//                 <div className="card-body">
//                   <h5 className="card-title">My Balance</h5>
//                   <h2 className="text-primary">{balance}</h2>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* BANK ACCOUNTS */}
//           <div className="row">
//             <div className="col-12">
//               <div className="card">
//                 <div className="card-header d-flex justify-content-between">
//                   <h5 className="mb-0">Bank Accounts</h5>
//                   <button
//                     className="btn btn-sm btn-outline-success"
//                     onClick={() => setShowAddBank(true)}
//                   >
//                     <AiOutlinePlus /> Add New
//                   </button>
//                 </div>

//                 <div className="card-body p-0">
//                   <table className="table table-bordered mb-0">
//                     <thead className="table-light">
//                       <tr>
//                         <th>Account Holder</th>
//                         <th>Bank Name</th>
//                         <th>Account Number</th>
//                         <th>IFSC</th>
//                         <th>Status</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {bankData.length > 0 ? (
//                         bankData.map((item) => (
//                           <tr key={item.id}>
//                             <td>{item.account_holder_name}</td>
//                             <td>{item.bank_name}</td>
//                             <td>{item.account_number}</td>
//                             <td>{item.ifsc_code}</td>
//                             <td>
//                               <span
//                                 className={
//                                   item.status === "active"
//                                     ? "status-active"
//                                     : "status-inactive"
//                                 }
//                               >
//                                 {item.status}
//                               </span>
//                             </td>
//                           </tr>
//                         ))
//                       ) : (
//                         <tr>
//                           <td colSpan="5" className="text-center">
//                             No bank details found
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* FOOTER */}
//           <footer className="footer mt-4 text-center">
//             <div className="container-fluid">© 2025 Seller Portal</div>
//           </footer>
//         </div>
//       </div>

//       {/* ADD BANK POPUP */}
//       <AddBankAccountPopup
//         show={showAddBank}
//         onClose={() => setShowAddBank(false)}
//         onSuccess={() => {
//           setShowAddBank(false);
//           fetchBankStatement();
//         }}
//       />
//     </>
//   );
// };

// /* ================= ADD BANK POPUP ================= */

// export const AddBankAccountPopup = ({ show, onClose, onSuccess }) => {
//   const seller_id = localStorage.getItem("seller_id");

//   const initialFormState = {
//     account_holder_name: "",
//     bank_name: "",
//     account_number: "",
//     ifsc_code: "",
//     status: "active",
//   };

//   const [formData, setFormData] = useState(initialFormState);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleInput = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const submitForm = async (e) => {
//     e.preventDefault();

//     if (!seller_id) {
//       toast.error("Seller ID not found");
//       return;
//     }

//     try {
//       setIsSubmitting(true);

//       const response = await axios.post(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_bank_statement",
//         { seller_id, ...formData }
//       );

//       if (response.data?.status) {
//         toast.success(response.data.message || "Bank account added successfully");
//         setFormData(initialFormState);
//         onSuccess();
//         onClose();
//       } else {
//         toast.error(response.data?.message || "Failed to add bank account");
//       }
//     } catch (error) {
//       console.error("Add Bank Error:", error);
//       toast.error("Something went wrong");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   if (!show) return null;

//   return (
//     <div className="modal fade show d-block custom-modal-overlay" tabIndex="-1">
//       <div className="modal-dialog modal-lg modal-dialog-centered">
//         <div className="modal-content">
//           {/* <div className="custom-modal-overlay">
//             <div className="custom-modal">
//               <div className="card shadow-lg border-0"></div> */}
//           <form onSubmit={submitForm}>
//             <div className="modal-header">
//               <h5 className="modal-title fw-semibold">Add Bank Account</h5>
//               <button type="button" className="btn-close" onClick={onClose}></button>
//             </div>

//             <div className="modal-body">
//               <div className="card mb-0">
//                 <div className="card-header">
//                   <h4 className="card-title mb-0">Bank Details</h4>
//                 </div>
//                 <div className="card-body">
//                   <div className="row">
//                     {[
//                       ["Account Holder Name", "account_holder_name"],
//                       ["Bank Name", "bank_name"],
//                       ["Account Number", "account_number"],
//                       ["IFSC Code", "ifsc_code"],
//                     ].map(([label, name]) => (
//                       <div className="col-lg-6" key={name}>
//                         <div className="mb-3">
//                           <label className="form-label">{label}</label>
//                           <input
//                             type="text"
//                             name={name}
//                             className="form-control"
//                             value={formData[name]}
//                             onChange={handleInput}
//                           />
//                         </div>
//                       </div>
//                     ))}

//                     <div className="col-lg-6">
//                       <label className="form-label">Status</label>
//                       <select
//                         className="form-control"
//                         name="status"
//                         value={formData.status}
//                         onChange={handleInput}
//                       >
//                         <option value="active">Active</option>
//                         <option value="inactive">Inactive</option>
//                       </select>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="modal-footer bg-light">
//               <button
//                 type="submit"
//                 className="btn btn-primary"
//                 disabled={isSubmitting}
//               >
//                 {isSubmitting ? "Saving..." : "Save Bank Account"}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };









import axios from "axios";
import React, { useEffect, useState } from "react";
import { AiOutlineDownload, AiOutlinePlus } from "react-icons/ai";
import { toast } from "react-toastify";
import { useRef } from "react";



export const SellerFinance = () => {
  const [bankData, setBankData] = useState([]);
  const [showAddBank, setShowAddBank] = useState(false);
  const hasFetched = useRef(false);

  const seller_id = localStorage.getItem("seller_id");
  console.log("Fetched Seller ID:", seller_id);

  const [incomeData] = useState([
    { id: 1, product: "Wireless Headphones", amount: "₹1,200", status: "To Release" },
    { id: 2, product: "Running Shoes", amount: "₹1,899", status: "Released" },
    { id: 3, product: "T-shirt - Cotton", amount: "₹599", status: "To Release" },
  ]);

  const [balance] = useState("₹5,450");


useEffect(() => {
  if (!seller_id) {
    toast.error("Seller ID not found");
    return;
  }

  if (hasFetched.current) return;
  hasFetched.current = true;

  fetchBankStatement();
}, [seller_id]);


  const fetchBankStatement = async () => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_by_id_bank_statement",
        { seller_id }
      );
      console.log("Seller ID:", seller_id)
      console.log("Bank Statement Response:", response.data);

      if (response.data.status && Array.isArray(response.data.data)) {
  setBankData(response.data.data);
} else {
  setBankData([]);
  toast.warning(response.data.message || "No bank data found");
}
    } catch (error) {
      console.error("Bank Statement Error:", error);
      toast.error("Failed to fetch bank statement");
    }
  };

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          {/* PAGE TITLE */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box">
                <h4 className="mb-0 fw-semibold">Finance Center</h4>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <a href="#">Dashboard</a>
                  </li>
                  <li className="breadcrumb-item active">Finance</li>
                </ol>
              </div>
            </div>
          </div>

          {/* INCOME OVERVIEW */}
          <div className="row mb-4">
            <div className="col-md-6">
              <div className="card">
                <div className="card-header d-flex justify-content-between">
                  <h5 className="mb-0">Income Overview</h5>
                  <button className="btn btn-sm btn-outline-primary">
                    <AiOutlineDownload /> Download Statement
                  </button>
                </div>
                <div className="card-body p-0">
                  <table className="table table-bordered mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Product</th>
                        <th>Amount</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {incomeData.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.product}</td>
                          <td>{item.amount}</td>
                          <td>
                            <span
                              className={`badge ${
                                item.status === "Released"
                                  ? "bg-success"
                                  : "bg-warning text-dark"
                              }`}
                            >
                              {item.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* BALANCE */}
            <div className="col-md-6">
              <div className="card text-center">
                <div className="card-body">
                  <h5 className="card-title">My Balance</h5>
                  <h2 className="text-primary">{balance}</h2>
                </div>
              </div>
            </div>
          </div>

          {/* BANK ACCOUNTS */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header d-flex justify-content-between">
                  <h5 className="mb-0">Bank Accounts</h5>
                  <button
                    className="btn btn-sm btn-outline-success"
                    onClick={() => setShowAddBank(true)}
                  >
                    <AiOutlinePlus /> Add New
                  </button>
                </div>

                <div className="card-body p-0">
                  <table className="table table-bordered mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>Account Holder</th>
                        <th>Bank Name</th>
                        <th>Account Number</th>
                        <th>IFSC</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bankData.length > 0 ? (
                        bankData.map((item) => (
                          <tr key={item.id}>
                            <td>{item.account_holder_name}</td>
                            <td>{item.bank_name}</td>
                            <td>{item.account_number}</td>
                            <td>{item.ifsc_code}</td>
                            <td>
                              <span
                                className={
                                  item.status === "active"
                                    ? "status-active"
                                    : "status-inactive"
                                }
                              >
                                {item.status}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No bank details found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {/* FOOTER */}
          <footer className="footer mt-4 text-center">
            <div className="container-fluid">© 2025 Seller Portal</div>
          </footer>
        </div>
      </div>

      {/* ADD BANK POPUP */}
      <AddBankAccountPopup
        show={showAddBank}
        onClose={() => setShowAddBank(false)}
        onSuccess={() => {
          setShowAddBank(false);
          fetchBankStatement();
        }}
      />
    </>
  );
};

/* ================= ADD BANK POPUP ================= */

export const AddBankAccountPopup = ({ show, onClose, onSuccess }) => {
  const seller_id = localStorage.getItem("seller_id");

  const initialFormState = {
    account_holder_name: "",
    bank_name: "",
    account_number: "",
    ifsc_code: "",
    status: "active",
  };

  const [formData, setFormData] = useState(initialFormState);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (!seller_id) {
      toast.error("Seller ID not found");
      return;
    }

    try {
      setIsSubmitting(true);

      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_bank_statement",
        { seller_id, ...formData }
      );

      if (response.data?.status) {
        toast.success(response.data.message || "Bank account added successfully");
        setFormData(initialFormState);
        onSuccess();
        onClose();
      } else {
        toast.error(response.data?.message || "Failed to add bank account");
      }
    } catch (error) {
      console.error("Add Bank Error:", error);
      toast.error("Something went wrong");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal fade show d-block custom-modal-overlay" tabIndex="-1">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          {/* <div className="custom-modal-overlay">
            <div className="custom-modal">
              <div className="card shadow-lg border-0"></div> */}
          <form onSubmit={submitForm}>
            <div className="modal-header">
              <h5 className="modal-title fw-semibold">Add Bank Account</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>

            <div className="modal-body">
              <div className="card mb-0">
                <div className="card-header">
                  <h4 className="card-title mb-0">Bank Details</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    {[
                      ["Account Holder Name", "account_holder_name"],
                      ["Bank Name", "bank_name"],
                      ["Account Number", "account_number"],
                      ["IFSC Code", "ifsc_code"],
                    ].map(([label, name]) => (
                      <div className="col-lg-6" key={name}>
                        <div className="mb-3">
                          <label className="form-label">{label}</label>
                          <input
                            type="text"
                            name={name}
                            className="form-control"
                            value={formData[name]}
                            onChange={handleInput}
                          />
                        </div>
                      </div>
                    ))}

                    <div className="col-lg-6">
                      <label className="form-label">Status</label>
                      <select
                        className="form-control"
                        name="status"
                        value={formData.status}
                        onChange={handleInput}
                      >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer bg-light">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Saving..." : "Save Bank Account"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};


